export const BREAKPOINTS = {
  XS: 480,
  S: 768,
  M: 1024,
  L: 1200,
  XL: 1440,
}
